import React from "react";
import MainAppGenericModal from "../../../../atoms/Modals/GenericModal";

import styles from "./MainApp.organisms.Category.Modals.EditCategoryModal.module.scss";
import i18n from "i18n";

export class DeleteCategoryModal extends React.Component {
  render() {
    const {
      open,
      category,
      handleClose
    } = this.props;

    const content = (<div className={styles["delete-category-modal-wrapper"]}>
      <div className={styles["delete-category-modal-title"]}>{i18n.t("delete.category")}</div>
  <div className={styles["delete-category-modal-text"]}>{i18n.t("delete.category.question")} &ldquo;{category ? category.name : ''}&ldquo;?</div>
      <div className={styles["delete-category-modal-buttons"]}>
        <div className={styles["delete-category-modal-button"]} onClick={this.props.cancel} data-automation-id="cancel">{i18n.t("cancel").toUpperCase()}</div>
        <div className={styles["delete-category-modal-button"]} onClick={this.props.confirm} data-automation-id="confirm">{i18n.t("delete.confirm").toUpperCase()}</div>
      </div>
    </div>)
    return (
      <div className={styles["delete-category-modal-container"]}>
          <MainAppGenericModal open={open} content={content} handleClose={handleClose}></MainAppGenericModal>
      </div>
    );
  }
}

DeleteCategoryModal.propTypes = {
};

export default DeleteCategoryModal;
